import Dexie, { type Table } from 'dexie';
import type { AppSettings, WatchlistEntry } from '../types';

export class AniPingDB extends Dexie {
  watchlist!: Table<WatchlistEntry, number>;
  settings!: Table<AppSettings, number>;

  constructor() {
    super('aniping');
    this.version(1).stores({
      watchlist: '++id, anilistId, status, nextEpisodeAiringAt, addedAt',
      settings: '++id',
    });
  }
}

export const db = new AniPingDB();

const DEFAULT_SETTINGS: AppSettings = {
  pushEnabled: false,
  pushSubscription: null,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  notifyMinutesBefore: 0,
  theme: 'dark',
};

export async function loadSettings(): Promise<AppSettings> {
  const all = await db.settings.toArray();
  if (all.length > 0) return all[0]!;
  const id = await db.settings.add(DEFAULT_SETTINGS);
  return { ...DEFAULT_SETTINGS, id };
}

export async function saveSettings(settings: AppSettings): Promise<void> {
  if (settings.id == null) {
    await db.settings.add(settings);
    return;
  }
  await db.settings.put(settings);
}
